import { useEntityPermission } from '@backstage/plugin-catalog-react/alpha';
import { ResourcePermission } from '@backstage/plugin-permission-common';

export const useGuard = (permission: ResourcePermission<'catalog-entity'>) => {
  return useEntityPermission(permission);
};
